export default __webpack_public_path__ + "static/media/scroll-top.6e7f567e.webp";